import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    'Event': [
      { label: 'Races', href: '#races' },
      { label: 'Event Guide', href: '#guide' },
      { label: 'Results', href: '#results' },
      { label: 'Photos', href: '#photos' }
    ],
    'Information': [
      { label: 'FAQs', href: '#faq' },
      { label: 'Contact', href: '#contact' },
      { label: 'Sponsors', href: '#sponsors' },
      { label: 'Volunteers', href: '#volunteers' }
    ],
    'Legal': [
      { label: 'Terms', href: '#terms' },
      { label: 'Privacy', href: '#privacy' },
      { label: 'Waiver', href: '#waiver' },
    ]
  };

  return (
    <footer className="bg-foreground text-white">
      <div className="container-wide py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-12 mb-12 lg:mb-16">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img 
              src="/run-camden-logo.png" 
              alt="Run Camden Logo" 
              className="h-12 sm:h-16 w-auto mb-6"
            />
            <p className="text-white/60 mb-6 text-base leading-relaxed max-w-sm">
              Camden's premier running festival. Join us for an unforgettable weekend of running and celebration.
            </p>
            
            {/* Social */}
            <div className="flex gap-3 mb-8">
              <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" aria-label="Facebook">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" aria-label="Twitter">
                <Twitter size={18} />
              </a>
              <a href="mailto:office@eliteenergy.com.au" className="w-10 h-10 sm:w-12 sm:h-12 bg-white/10 flex items-center justify-center hover:bg-primary transition-colors" aria-label="Email">
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm uppercase tracking-widest font-bold mb-4 lg:mb-6">{title}</h4>
              <ul className="space-y-2 lg:space-y-3">
                {links.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.href}
                      className="text-white/60 hover:text-white transition-colors text-sm"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Elite Energy Section */}
        <div className="border-t border-white/10 pt-10 lg:pt-12 mb-10 lg:mb-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            {/* Elite Energy Contact */}
            <div>
              <img 
                src="https://customer-assets.emergentagent.com/job_festival-prototype/artifacts/v0la4t19_Elite-Energy-Reversed-updated.svg" 
                alt="Elite Energy" 
                className="h-14 sm:h-16 w-auto mb-5 opacity-90"
              />
              <div className="space-y-2 text-sm text-white/70">
                <div className="flex items-start gap-2">
                  <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                  <span>15 Haigh Avenue, Nowra, NSW, 2541, Australia</span>
                </div>
                <div className="flex items-center gap-2">
                  <Phone size={16} className="flex-shrink-0" />
                  <a href="tel:0244237775" className="hover:text-white transition-colors">02 4423 7775</a>
                </div>
                <div className="flex items-center gap-2">
                  <Mail size={16} className="flex-shrink-0" />
                  <a href="mailto:office@eliteenergy.com.au" className="hover:text-white transition-colors">office@eliteenergy.com.au</a>
                </div>
              </div>
            </div>

            {/* Acknowledgment */}
            <div className="lg:text-right">
              <p className="text-sm text-white/50 leading-relaxed max-w-md lg:ml-auto">
                Elite Energy acknowledges the traditional owners of the land on which we live and work. We pay respect to their elders – past, present and future.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-6 lg:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-xs sm:text-sm text-white/60">
            <p>
              © {currentYear} Run Camden. All rights reserved.
            </p>
            <p>
              Designed for athletes, by athletes.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
